/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'feedback-collector.anonymous': 'Tato zpětná vazba je odesílána anonymně. Společnost Atlassian vás ohledně této zpětné vazby nebude moci přímo kontaktovat.',
  'feedback-collector.anonymous.title': 'Anonymní zpětná vazba',
  'feedback-collector.can-be-contacted.label': 'Ano, týmy Atlassian mě mohou kontaktovat ohledně mých zkušeností a pomoci s vylepšováním produktů a služeb společnosti Atlassian. Potvrzuji, že znám <a>Zásady ochrany osobních údajů společnosti Atlassian</a>.',
  'feedback-collector.cancel-button.label': 'Zrušit',
  'feedback-collector.default.custom.textarea.label': 'Co si myslíte?',
  'feedback-collector.enrol-in-research.label': 'Chci se zúčastnit produktového průzkumu',
  'feedback-collector.feedback-title': 'Sdělte nám svůj názor',
  'feedback-collector.form.bug.label': 'Popsat chybu nebo problém',
  'feedback-collector.form.comment.label': 'Dejte nám vědět, co si myslíte',
  'feedback-collector.form.empty.label': 'Vyberte možnost',
  'feedback-collector.form.question.label': 'Co byste chtěli vědět?',
  'feedback-collector.form.suggestion.label': 'Dejte nám vědět, co byste chtěli zlepšit',
  'feedback-collector.option.bug.label': 'Ohlásit chybu',
  'feedback-collector.option.comment.label': 'Zanechat komentář',
  'feedback-collector.option.default.label': 'Vybrat zpětnou vazbu',
  'feedback-collector.option.default.placeholder': 'Vyberte jednu možnost.',
  'feedback-collector.option.question.label': 'Položit otázku',
  'feedback-collector.option.suggestion.label': 'Navrhnout zlepšení',
  'feedback-collector.required.fields.summary': 'Povinná pole jsou označena hvězdičkou.',
  'feedback-collector.submit-button.label': 'Odeslat zpětnou vazbu',
  'feedback-collector.success-flag.description': 'Vaše cenná zpětná vazba nám pomáhá neustále zlepšovat naše produkty.',
  'feedback-collector.success-flag.title': 'Díky!',
  'feedback-collector.summary-placeholder': 'Dejte nám vědět, co si myslíte',
  'proforma-form-builder.feedback-icon-label': 'Zpětná vazba',
  'proforma-form-builder.give-feedback': 'Poskytnout zpětnou vazbu'
};